import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewOrgPageContainerWrapperLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewOrgPage" */
      './ViewOrgPageContainerWrapper.dynamic'
    ),
  loading: LoadingPageLoadable,
});
